import { PERMISSIONS } from "@/constants";

export default [
    {
        name: "analytics",
        meta: {
            title: "Analytics",
            requiresAuth: true,
            permission_scopes: [PERMISSIONS.ANALYTICS_ALL],
        },
        path: "/manage/analytics",
        component: () => import("@/views/pages/analytics/index.vue"),
    }
]